import type { CollectionModelDrawable } from './drawable';
import type { CollectionModelDrawableMarker } from './marker.drawable';
import type { CollectionModelDrawableMarkerOffset } from './marker.offset.drawable';
import type { CollectionModelDrawableMask } from './mask.drawable';
import type { CollectionModelDrawableVerticalSeparation } from './vertical.separation.drawable';

export function isMarker(d: CollectionModelDrawable): d is CollectionModelDrawableMarker {
	return d.isMarker;
}

export function isBaseMarker(d: CollectionModelDrawable): d is CollectionModelDrawableMarker {
	return d.isBase;
}

export function isBaseOffsetMarker(d: CollectionModelDrawable): d is CollectionModelDrawableMarkerOffset {
	return d.isBaseOffset;
}

export function isVerticalSeparationDrawable(
	d: CollectionModelDrawable
): d is CollectionModelDrawableVerticalSeparation {
	return d.isVerticalSeparation;
}

export function isMask(d: CollectionModelDrawable): d is CollectionModelDrawableMask {
	return d.isMask;
}
